module.exports = __webpack_public_path__ + "static/media/logo.da63e41d.png";